export default __webpack_public_path__ + "static/media/ic_northern_marianas_islands.91d46997.svg";